<template>
    <crud-show :title="title" :open="open"  @close="$emit('close')">

        <v-card-text>
            <agencia-show-data :item="item" />
        </v-card-text>

  </crud-show>
</template>

<script>
    import AgenciaShowData from "./AgenciaShowData";
    import {CrudShow} from '@dracul/common-frontend'
 
    export default {
        name: "AgenciaShow",
        components: {CrudShow, AgenciaShowData},
        props: {
            open: {type: Boolean, default: true},
            item: {type: Object, required: true}
        },
        data() {
            return {
                title: 'cobrox.agencia.showing',
            }
        },
    }
</script>

